import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ProjectContainer = styled.div`
    background-color: #F6F6F6;
    border-radius: 20px;
    border: 2px solid white;
    padding: 20px;
    margin: 20px 0;
    position:relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
`

const BesoinEditor = (props) => {

    const { i18n } = useTranslation('common');

    function addProjet(e){
        e.preventDefault()
        var newid = Math.random().toString(36).substr(2, 9);
        props.setProjets(oldArray => [...oldArray,{_id: newid ,userId: null, description: '', typologie: '', savoirfaire: '', dp: '', dpetai: '', da: '', précisions: '', validated: false}])
    }

    function removeProjet(e,id){
        e.preventDefault()
        props.setDeletedProjets(oldArray => [...oldArray, id])
        props.setProjets(oldArray => oldArray.filter(proj => proj._id !== id))
    }

    function validateProject(e,projId){
        e.preventDefault()
        let _projets = [...props.projets]
        for(let i=0;i<_projets.length;i++){
            if(_projets[i]._id === projId){

                // console.log(_projets[i])
                if(
                    _projets[i].description === '' ||
                    (!_projets[i].dp &&
                    !_projets[i].dpetai &&
                    !_projets[i].da)
                ){
                    alert(i18n.language === "fr" ? "Veuillez remplir tous les champs obligatoires" : "Please fill all mandatory fields")
                    return
                }

                _projets[i].validated = true
            }
        }
        props.setProjets(_projets)
    }

    function onFieldChange(e){
        let projId = e.target.name.split("_")[1]
        let field = e.target.name.split("_")[0]
        let _projets = [...props.projets]
        for(let i=0;i<_projets.length;i++){
            if(_projets[i]._id === projId){
                _projets[i][field] = e.target.value || e.target.checked
            }
        }
        props.setProjets(_projets)
    }

    return (
        <div>
            <br/>
            {props.projets && props.projets.map((projet,i) =>
                <ProjectContainer key={projet._id} style={ projet.validated ? {borderColor:"rgb(144, 221, 144)"} : {}}>
                    <h3 className='blacklower'>{i18n.language === "fr" ? "Projet " : "Project "}{i + 1}</h3><br/>
                    <h3>{i18n.language === "fr" ? "Description du projet" : "Project description"}*</h3>
                    <label>
                        {i18n.language === "fr" ? "Merci de bien vouloir nous transmettre vos besoins et attentes. Soit un projet précis défini selon vos axes de développement, soit l'objectif de votre participation: rencontre de nouveaux designers, identité de marque, stratégie d'image, direction artistique, développement produits, autres." : "Please provide us with your needs and expectations. Either a specific project defined according to your development axes, or the objective of your participation: meeting new designers, brand identity, image strategy, artistic direction, product development, others."}<br/>
                        <textarea disabled={projet.validated} type="text" name={"description_"+projet._id} placeholder={i18n.language === "fr" ? "Description" : "Description"} defaultValue={projet.description} onChange={onFieldChange}/>
                    </label>
                    <label>
                        {i18n.language === "fr" ? "Typologie(s) de mobiliers / objet / produits" : "Typology(ies) of furniture / object / products"}<br/>
                        <input disabled={projet.validated} type="text" name={"typologie_"+projet._id} placeholder={i18n.language === "fr" ? "Typologie" : "Typologie"} defaultValue={projet.typologie} onChange={onFieldChange}/>
                    </label>
                    <label>
                        {i18n.language === "fr" ? "Savoir-faire, matériaux et techniques" : "Know-how, materials and techniques"}<br/>
                        <input disabled={projet.validated} type="text" name={"savoirfaire_"+projet._id} placeholder={i18n.language === "fr" ? "Savoir-faire" : "Know-how"} defaultValue={projet.savoirfaire} onChange={onFieldChange}/>
                    </label>
                    <span>{i18n.language === 'fr' ? "Profil du créateur recherché" : "Profile of the creator sought"}*</span>
                    <br/> <br/>
                    <div className="decal">
                        <label><input type="checkbox" onChange={onFieldChange} name={"dp_"+projet._id} defaultChecked={projet?.dp}/>{i18n.language === 'fr' ? "Designer produit" : "Product designer"}</label>
                        <label><input type="checkbox" onChange={onFieldChange} name={"dpetai_"+projet._id} defaultChecked={projet?.dpetai}/>{i18n.language === 'fr' ? "Designer produit et architecte d’intérieur" : "Product designer and interior architect"}</label>
                        <label><input type="checkbox" onChange={onFieldChange} name={"da_"+projet._id} defaultChecked={projet?.da}/>{i18n.language === 'fr' ? "Directeur artistique" : "Artistic director"}</label>
                    </div>
                    <label>
                        {i18n.language === "fr" ? "Précision sur le profil du créateur recherché (designer émergeant, talent confirmé, reconnu à l’international,....)" : "Precision on the profile of the creator sought (emerging designer, confirmed talent, internationally recognized, ....)"}<br/>
                        <input disabled={projet.validated} type="text" name={"précisions_"+projet._id} placeholder={i18n.language === "fr" ? "Précisions" : "Precision"} defaultValue={projet.précisions} onChange={onFieldChange}/>
                    </label>
                    {projet.validated ?
                        <div className='announcement green'>{i18n.language === "fr" ? "✓  Projet validé" : "✓  Project validated"}</div>
                    :
                        <button style={{float:"left"}} className='dualbuttons' onClick={(e)=>validateProject(e,projet._id)}>{i18n.language === "fr" ? "Confirmer" : "Confirm"}</button>
                    }
                    <button style={{float:"right"}} className='red_button dualbuttons' onClick={(e)=>removeProjet(e,projet._id)}>{i18n.language === "fr" ? "Supprimer" : "Delete"}</button>
                    <br/>
                </ProjectContainer>
            )}
            {!props.projets.find(proj => !proj.validated) && <button className='centered' onClick={addProjet}>{i18n.language === "fr" ? "+ Ajouter un projet" : "+ Add a project"}</button>}
            <br/>
        </div>
    );
};

export default BesoinEditor;